module.exports = __webpack_public_path__ + "static/media/app-store.5bbc6367.png";